import React from 'react'
import { useHistory } from 'react-router-dom';
import Header from './common/Header';
import Close_white from "../assets/white-close.svg";
import { useSelector } from 'react-redux';

function AccountLogin() {
    const history = useHistory();
    const profileDetails = useSelector((state) => state.profileDetails)

    const onGoBack = () => {
        history.push("/dashboards")
    }
    return (
        <>
            <div className='wrapper'>
                <div className='middle-content-wrap iframe-Container'>
                <div className='bordr-bottom-div'></div>
                    <button type="button" className="close mb-2">
                        <span aria-hidden="true">
                            <img src={Close_white} className="closeButton" alt="" onClick={onGoBack} />
                        </span>
                    </button>
                 
                    <iframe className='link-account' src={profileDetails?.cp_creators?.[0]?.dashboard_link || ""} frameborder="0">
                      
                    </iframe>
              
                </div>
            </div>

        </>
    )
}

export default AccountLogin